import React from 'react';
import { useNavigate } from 'react-router-dom';
// Using a simple arrow character instead of an icon
import Header from '../../components/Header/Header';
import './Home.css';

const AppCard: React.FC<{
  name: string;
  description: string;
  icon: React.ReactNode;
  path: string;
  comingSoon?: boolean;
}> = ({ name, description, icon, path, comingSoon = false }) => {
  const navigate = useNavigate();
  
  const handleClick = (e: React.MouseEvent) => {
    if (!comingSoon) {
      navigate(path);
    }
  };

  return (
    <div 
      className={`app-card ${comingSoon ? 'coming-soon' : ''}`} 
      onClick={handleClick}
      aria-label={comingSoon ? `${name} (Coming Soon)` : name}
    >
      <div className="app-icon">
        {icon}
      </div>
      <div className="app-content">
        <div className="app-header">
          <h3>{name}</h3>
          {comingSoon && <span className="badge">Coming Soon</span>}
        </div>
        <p>{description}</p>
        {!comingSoon && (
          <div className="app-link">
            <span>Open App</span>
            <span className="arrow-icon">→</span>
          </div>
        )}
      </div>
    </div>
  );
};

const Home: React.FC = () => {
  const apps = [
    {
      id: 'ainstein',
      name: 'AInstein',
      description: 'Your AI-powered learning assistant that helps students with personalized study plans, instant answers, and interactive learning experiences.',
      icon: <img 
        src={require('../../apps/ainstein/assets/images/icon.png')}
        alt="AInstein"
        style={{ width: '100%', height: '100%', objectFit: 'contain' }}
      />,
      path: '/ainstein',
      comingSoon: false
    },
    {
      id: 'math-genius',
      name: 'Math Genius',
      description: 'Master mathematics with step-by-step solutions, practice problems, and personalized learning paths.',
      icon: <div className="app-icon-placeholder">🧮</div>,
      path: '#',
      comingSoon: true
    },
    {
      id: 'code-master',
      name: 'Code Master',
      description: 'Learn to code with interactive tutorials, real-time feedback, and project-based learning.',
      icon: <div className="app-icon-placeholder">💻</div>,
      path: '#',
      comingSoon: true
    },
  ];

  return (
    <div className="home">
      <Header />
      <div className="home-content">
        <section className="hero-section">
          <h1>Welcome to EduMorph</h1>
          <p className="subtitle">Transforming education through innovative learning tools</p>
          <p className="description">
            Discover our suite of educational applications designed to enhance learning experiences 
            and make education more engaging, accessible, and effective for everyone.
          </p>
        </section>

        <section className="apps-section">
          <div className="section-header">
            <h2>Our Learning Apps</h2>
            <p className="section-description">Explore our growing collection of educational tools</p>
          </div>
          
          <div className="apps-grid">
            {apps.map((app) => (
              <AppCard key={app.id} {...app} />
            ))}
          </div>
        </section>
      </div>
    </div>
  )
};

export default Home;
